export const mathjaxConfig = {
  loader: {
    load: ['[tex]/boldsymbol'],
  },
  tex: {
    packages: { '[+]': ['html', 'boldsymbol'] },
    inlineMath: [
      // display inline
      ['$', '$'],
      ['$$', '$$'], // usually displayMath -> display block
      ['\\[', '\\]'], // usually displayMath -> display block
      ['\\(', '\\)'],
    ],
    displayMath: [], // display block
  },
};
